export default class Menu
{
    constructor(_options)
    {
        this.music = _options.music
        this.element = document.querySelector('.js-game-menu')
        this.toggleButton = this.element.querySelector('.js-menu-toggle')
        this.panel = this.element.querySelector('.js-menu-panel')
        this.playButton = this.element.querySelector('.js-music-toggle')
        this.volumeInput = this.element.querySelector('.js-music-volume')
        this.milestoneButton = this.element.querySelector('.js-menu-milestone')
        this.isOpen = false

        this.toggleButton.addEventListener('click', () => this.setOpen(!this.isOpen))
        this.element.querySelector('.js-menu-restart').addEventListener('click', () => _options.onRestart())
        this.playButton.addEventListener('click', () => this.music.toggle())
        this.element.querySelector('.js-music-next').addEventListener('click', () => this.music.playNext())
        this.volumeInput.addEventListener('input', () => this.music.setVolume(Number(this.volumeInput.value)))
        this.milestoneButton.addEventListener('click', () =>
        {
            this.milestoneButton.title = _options.onAdvanceMilestone()
        })

        this.music.audio.addEventListener('play', () => this.updatePlayState())
        this.music.audio.addEventListener('pause', () => this.updatePlayState())
        this.music.audio.addEventListener('volumechange', () => this.updateVolume())

        document.addEventListener('pointerdown', (_event) =>
        {
            if(this.isOpen && !this.element.contains(_event.target))
                this.setOpen(false)
        })
        document.addEventListener('keydown', (_event) =>
        {
            if(_event.key === 'Escape' && this.isOpen)
                this.setOpen(false, true)
        })
        this.element.addEventListener('keydown', (_event) =>
        {
            if(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'KeyW', 'KeyA', 'KeyS', 'KeyD'].includes(_event.code))
                _event.stopPropagation()
        })

        this.updatePlayState()
        this.updateVolume()
    }

    setOpen(_open, _restoreFocus = false)
    {
        this.isOpen = _open
        this.element.classList.toggle('is-open', _open)
        this.toggleButton.setAttribute('aria-expanded', String(_open))
        this.toggleButton.setAttribute('aria-label', _open ? 'Close menu' : 'Open menu')
        this.panel.setAttribute('aria-hidden', String(!_open))
        this.panel.inert = !_open

        if(_restoreFocus)
            this.toggleButton.focus()
    }

    updatePlayState()
    {
        const isPlaying = !this.music.audio.paused
        const label = isPlaying ? 'Pause music' : 'Play music'
        this.playButton.classList.toggle('is-playing', isPlaying)
        this.playButton.setAttribute('aria-label', label)
        this.playButton.title = label
    }

    updateVolume()
    {
        const volume = this.music.audio.volume
        this.volumeInput.value = volume
        this.volumeInput.style.setProperty('--volume', `${volume * 100}%`)
        this.volumeInput.setAttribute('aria-valuetext', `${Math.round(volume * 100)}%`)
        this.volumeInput.closest('.menu-volume').classList.toggle('is-muted', volume === 0)
    }
}
